import { render, staticRenderFns } from "./LabBackground.vue?vue&type=template&id=5c701bb6&scoped=true"
import script from "./LabBackground.vue?vue&type=script&lang=js"
export * from "./LabBackground.vue?vue&type=script&lang=js"
import style0 from "./LabBackground.vue?vue&type=style&index=0&id=5c701bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c701bb6",
  null
  
)

export default component.exports